import TContractEditPayment from './index.vue';

TContractEditPayment.install = app => {
  app.component(TContractEditPayment.name, TContractEditPayment);
};

export default TContractEditPayment;
